<script>
  import 'regenerator-runtime/runtime'
  import _ from 'lodash';
  import { debounce } from '../api/debounce'
  import { select, click } from '../api/element-manipulation'
  import { endpointFetch } from '../api/standard-endpoints'
  import { applyQueryTokens } from '../api/url-query-tokens'
  export let configuration

  const filters = configuration.filters
  const endpoint = configuration.endpoint
  const networkErrorMessage = configuration.networkErrorMessage
  let placeholder = configuration.placeholder
  let resultsHeading = configuration.resultsHeading
  let detailedSearchParagraph = configuration.detailedSearchParagraph
  let searchButton = configuration.searchButton

  const mobileToggle = select(document, '[data-hook~="openSearchBar"]')
  let mobileOpen = false
  let desktop = false

  let selectedFilter = filters[0].value
  $: searchPageUrl = filters.filter( filt => filt.value === selectedFilter)[0].searchPageUrl
  $: selectedIcon = filters.filter( filt => filt.value === selectedFilter)[0].icon
  let keywords = ''
  let results = []

  const getIcon = (type) => {
    return filters.find(x => x.value === type).icon
  }

  const getSearchPageUrl = (searchPageUrl, keywords) => {
    const values = {
      keywords
    }
    return applyQueryTokens(searchPageUrl, values)
  }

  const onCloseClick = () => {
    mobileOpen = false
  }
  const onToggleClick = () => {
    // console.log("onToggleClick")
    mobileOpen = !mobileOpen
  }

  const getSearchResults = async () =>{
    const response = await endpointFetch(
      applyQueryTokens (endpoint, {
        keywords,
      }), null, networkErrorMessage
    )
    console.log(response)
    if(response.code == '200'){
      results = response.results
    }
  }

  const resize = () => {
    desktop = window.innerWidth >= 800
  }
  const onKeyDown = (e) => {
    //TODO listen for escape and close search bar?
    // console.log("key",e)
  }

  const searchDebouncedRequest = debounce(getSearchResults, configuration.requestDebounce, false)
  window.addEventListener('resize', debounce(resize, 150))
  document.addEventListener('keydown', onKeyDown)

  resize()
  click(mobileToggle, onToggleClick)

  $: searchDebouncedRequest(keywords)
</script>

{#if desktop || mobileOpen }
<div class="p-absolute 800:p-relative inset-0 z-200">
  <div class="w-1/1 800:w-400 px-sides 800:px-0 py-16 800:py-0 bg-dkblue 800:bg-transparent d-flex flex-no-wrap items-center">
    <button on:click={onCloseClick} type="button" class="bg-dkblue text-white 800:d-none mr-16">
      <svg class="w-24 h-24 fill-current d-block mx-auto"
          viewBox="0 0 24 24">
          <path d="M23.6,22.2c0.4,0.4,0.4,1,0.1,1.4s-1,0.4-1.4,0.1c0,0,0,0-0.1-0.1
    L11.9,13.3L1.6,23.6c-0.4,0.4-1,0.4-1.4,0.1s-0.4-1-0.1-1.4c0,0,0,0,0.1-0.1l10.3-10.3L0.2,1.6c-0.4-0.4-0.3-1,0.1-1.4
    c0.4-0.3,0.9-0.3,1.3,0l10.3,10.3L22.2,0.2c0.4-0.4,1-0.4,1.4-0.1c0.4,0.4,0.4,1,0.1,1.4c0,0,0,0-0.1,0.1L13.3,11.9L23.6,22.2z"/>
      </svg>
      <span class="text-center">Close</span>
    </button>
    <div class="header--search-input w-1/1 d-flex items-center justify-between bg-white"
      role="presentation">
      <input
        bind:value={keywords}
        class="flex-grow-0 flex-shrink-0 w-1/1 border-1 border-c6 border-solid bg-truewhite text-black outline-none py-8 px-16 text-14 italic"
        placeholder={placeholder}
        name="s"
        id="search"
        type="text"
      >
    </div>
  </div>

  {#if keywords.length > 2 }
  <div class="header--quick-results w-400 mx-auto p-relative 800:p-absolute z-100">

    {#if results.length > 0}
    <div class="header--quick-results--list bg-white p-16">
      <span class="d-block text-14 font-f1 tracking-5 leading-125 font-400 uppercase pb-8">
        { resultsHeading }
      </span>
      <ul>
        {#each results as result}
        <li class="mb-16">
          <a href="{result.link}" class="d-flex flex-no-wrap font-700 uppercase items-start hover:underline">
            <svg class="icon w-24 h-24 mr-8 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              {@html _.unescape(getIcon(result.icon))}
            </svg>
            {@html result.label}
          </a>
        </li>
        {/each}
      </ul>
    </div>
    {/if}
    <div class="bg-ltgrey p-16 text-dkblue">
      <p class="text-14 font-f1 tracking-5 leading-125 font-400 pb-32">
        { detailedSearchParagraph }
      </p>
      <div class="d-flex flex-no-wrap w-1/1">
        <div class="w-1/1 border-b-2 border-grey mr-16 d-flex items-center" role="presentation">
          <svg class="icon w-24 h-24 mr-8 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            {@html _.unescape(selectedIcon)}
          </svg>
          <select
            bind:value={selectedFilter}
            class="w-1/1--24 font-700 uppercase bg-transparent search-select"
            aria-label="filter">
            {#each filters as filter}
              <option value="{filter.value}">
              {filter.label}</option>
            {/each}
          </select>
        </div>
        <a href="{getSearchPageUrl(searchPageUrl, keywords)}"
          class="flex-grow-0 flex-shrink-0 bg-dkblue h-32 px-12 d-flex items-center border-0 transition-fast text-white hover:bg-ltblue"
          data-hook="modal.openButton"
          data-modal-id="search"
          type="button">
          <span class="d-block pr-8 text-14 font-700 font-f1 leading-125 tracking-0">
            { searchButton }
          </span>
          <svg class="w-24 h-24 fill-current d-block mx-auto"
            viewBox="0 0 24 24">
            <path d="M15.5,14h-.79l-.28-.27a6.51,6.51,0,1,0-.7.7l.27.28v.79l5,4.99L20.49,19Zm-6,0A4.5,4.5,0,1,1,14,9.5,4.494,4.494,0,0,1,9.5,14Z" fill="currentColor"/>
          </svg>
        </a>
      </div>

    </div>

  </div>
  {/if}
</div>
{/if}
